import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppointmentModalProvider } from './context/AppointmentModalContext';
import MainPage from './components/MainPage';
import AboutMe from './components/AboutMe';
import Leistungen from './components/Leistungen';
import Contact from './components/Contact';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import Impulse from './components/Impulse';
import Stimmen from './components/Stimmen';
import Vortraege from './components/Vortraege';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';
import AppointmentModal from './components/AppointmentModal';
import { I18nProvider } from './i18n/I18nContext';
import './App.css';

function App() {
  return (
    <I18nProvider>
    <AppointmentModalProvider>
      <div className="caro-app">
        <ScrollToTop />
        <AnalyticsRouteTracker />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/welcome" element={<MainPage />} />
          <Route path="/ueber-mich" element={<AboutMe />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/vortraege" element={<Vortraege />} />
          <Route path="/impulse" element={<Impulse />} />
          <Route path="/stimmen" element={<Stimmen />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/en" element={<MainPage />} />
          <Route path="/en/about" element={<AboutMe />} />
          <Route path="/en/services" element={<Leistungen />} />
          <Route path="/en/speaking" element={<Vortraege />} />
          <Route path="/en/insights" element={<Impulse />} />
          <Route path="/en/testimonials" element={<Stimmen />} />
          <Route path="/en/contact" element={<Contact />} />
          <Route path="/en/legal-notice" element={<Impressum />} />
          <Route path="/en/privacy" element={<Datenschutz />} />
        </Routes>
        <CookieBanner />
        <AppointmentModal />
      </div>
    </AppointmentModalProvider>
    </I18nProvider>
  );
}

export default App;
